import Buyers from 'modules/buyer/list';
import Header from 'modules/header/wholesaler/home';

const BuyersPage = () => {
  return (
    <>
      <Header />
      <Buyers app="market" />
    </>
  );
};

export default BuyersPage;
